// extracted by mini-css-extract-plugin
export var fadeInOut = "_4a-3";
export var icon = "_4a-4";
export var savedIndicator = "_4a-2";
export var savingIndicator = "_4a-0";
export var spin = "_4a-1";